//hooks what's define in query params ?dev=true
import {useEffect} from "react";
import {Store} from "pullstate";
import {firebaseService} from "../service/firebase";
import {Api} from "../pages/login/api/api";
import {AppStore} from "../useAppPullState";


const defaultState = {
    token: null,
    error: null,
    loading: true,
    loggedIn: false,
}

export const reset = () => {
    MagicLinkLoginStore.update(s => {
        s.token = null;
        s.error = null;
        s.loading = true;
        s.loggedIn = false;
    });
}

export const MagicLinkLoginStore = new Store(defaultState);

const setToken = (token) => {
    MagicLinkLoginStore.update(s => {
        s.token = token;
    });
};

const pause = (seconds) => {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, seconds * 1000);
    });
}

const setLoading = (loading) => {
    MagicLinkLoginStore.update(s => {
        s.loading = loading;
    });
}
export const LinkLogin = {
    useState: MagicLinkLoginStore.useState,
    setToken,
    setError: (error) => {
        MagicLinkLoginStore.update(s => {
            s.error = error;
        });
    },
    useToken: () => {
        return MagicLinkLoginStore.useState(s => s.token);
    },
    useIsMagicLogin: () => {
        return MagicLinkLoginStore.useState(s => s.token !== null);
    },
    useParamsToDefineToken: () => {
        useEffect(() => {
            const params = new URLSearchParams(window.location.search);
            const reset = params.get('login-via-secret');
            setToken(reset);
        }, [])
    },
    useLoginLoadEffect: () => {
        const token = LinkLogin.useToken();
        const user = AppStore.useState(s => s.user);
        useEffect(() => {
            if(token){
                setLoading(true);
                Api.loginViaMagicLink(token).then(async ({error, token}) => {
                    if (error) {
                        await pause(1.4);
                        await LinkLogin.setError(error);
                        setLoading(false);
                    } else {
                        await firebaseService.viaToken(token)
                    }


                })
            }

        }, [token]);

        useEffect(() => {
            if(user){
                reset();
            }
        }, [user]);
    }
}
